import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetDossierAutomationsDebugController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAutomationsDebugController.php
* @route '/api/dossier/{dossier}/automations/debug'
*/
const GetDossierAutomationsDebugController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierAutomationsDebugController.url(args, options),
    method: 'get',
})

GetDossierAutomationsDebugController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/automations/debug',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetDossierAutomationsDebugController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAutomationsDebugController.php
* @route '/api/dossier/{dossier}/automations/debug'
*/
GetDossierAutomationsDebugController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDossierAutomationsDebugController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetDossierAutomationsDebugController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAutomationsDebugController.php
* @route '/api/dossier/{dossier}/automations/debug'
*/
GetDossierAutomationsDebugController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierAutomationsDebugController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetDossierAutomationsDebugController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAutomationsDebugController.php
* @route '/api/dossier/{dossier}/automations/debug'
*/
GetDossierAutomationsDebugController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierAutomationsDebugController.url(args, options),
    method: 'head',
})

export default GetDossierAutomationsDebugController